import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

/**
 * Page component that handles transparent sign-on, redirects, and clean URLs.
 * @private
 */
@UntilDestroy()
@Component({
  selector: 'assess-callback-page',
  templateUrl: './callback-page.component.html',
  styles: [':host { display: block; }', '.container { height: 100vh; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallbackPageComponent implements OnInit {
  constructor(
    private readonly authService: AuthService,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit() {
    const params = this.route.snapshot.queryParamMap;

    if (params.has('error')) {
      return this.authService.logout({ logoutParams: { returnTo: window.location.origin } });
    }

    if (params.has('code') && params.has('state')) {
      return this.authService.handleRedirectCallback().pipe(untilDestroyed(this)).subscribe();
    }

    return this.authService.loginWithRedirect().pipe(untilDestroyed(this)).subscribe();
  }
}
